import React from 'react'

const LoadingHomeScreen = () => {
  return (
    <>
     <div className=" bg-light"> 
              <section className="container py-4">
  <div className="hero-wrap border border-white border-3 shadow p-4 p-lg-0">

    <div className="row align-items-center g-4 mt-50 mb-50">
      <div className="col-lg-8">
        <div className="p-lg-4 ms-lg-5">

          {/* Brand line */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <div className="skeleton rounded" style={{ width: "60px", height: "20px" }} />
            <div className="skeleton rounded" style={{ width: "10px", height: "20px" }} />
            <div className="skeleton rounded" style={{ width: "80px", height: "20px" }} />
          </div>

          {/* Heading */}
          <div className="skeleton rounded mb-2" style={{ width: "90%", height: "36px" }} />
          <div className="skeleton rounded mb-3" style={{ width: "70%", height: "36px" }} />

          {/* Features */}
          <div className="d-flex flex-wrap gap-4 mb-4">
            {[1, 2, 3].map((_, i) => (
              <div key={i} className="d-flex align-items-center gap-2">
                <div className="skeleton rounded-circle" style={{ width: "18px", height: "18px" }} />
                <div className="skeleton rounded" style={{ width: "120px", height: "14px" }} />
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="skeleton rounded" style={{ width: "180px", height: "42px" }} />
        </div>
      </div>

      {/* Right Image Placeholder */}
      <div className="col-lg-4">
        <div
          className="skeleton w-100 rounded"
          style={{ height: "300px" }}
        />
      </div>
    </div>
  </div>
</section>

<div className="container mt-4 px-0 mb-4">
  <div className="row text-center g-0 rounded-4 shadow-sm bg-white border py-3">

    {Array.from({ length: 7 }).map((_, i) => (
      <div key={i} className="col-6 col-md border-end">
        <div className="d-flex flex-column align-items-center gap-1">
          <div className="skeleton rounded" style={{ width: "60px", height: "20px" }} />
          <div className="skeleton rounded" style={{ width: "90px", height: "14px" }} />
        </div>
      </div>
    ))}

  </div>
</div>

</div>

<section className="container py-5 mb-50">
  {/* Header Skeleton */}
  <div className="d-flex align-items-center justify-content-between mb-4 pb-4">
    <div className="skeleton rounded" style={{ width: "360px", height: "28px" }} />
    <div className="d-flex gap-2">
      <div className="skeleton rounded-circle" style={{ width: "34px", height: "34px" }} />
      <div className="skeleton rounded-circle" style={{ width: "34px", height: "34px" }} />
    </div>
  </div>

  {/* Cards Skeleton */}
  <div className="row g-3">
    {Array.from({ length: 4 }).map((_, index) => (
      <div className="col-6 col-md-3" key={index}>
        <div className="video-card">

          {/* Thumbnail Skeleton */}
          <div className="video-thumb position-relative">
            <div
              className="skeleton w-100 rounded"
              style={{ height: "180px" }}
            />

            {/* Play button placeholder */}
            <div
              className="skeleton rounded-circle position-absolute top-50 start-50 translate-middle"
              style={{ width: "44px", height: "44px" }}
            />
          </div>

          {/* Text Skeleton */}
          <div className="p-3">
            <div className="skeleton rounded mb-2" style={{ width: "85%", height: "14px" }} />
            <div className="skeleton rounded" style={{ width: "60%", height: "12px" }} />
          </div>

        </div>
      </div>
    ))}
  </div>
</section>


</>
  )
}

export default LoadingHomeScreen